<template>
  <div class="pt-md-2">
    <form-wizard
      color="#5540d6"
      :title="null"
      :subtitle="null"
      finish-button-text="Submit"
      back-button-text="Previous"
      class="steps-transparent mb-md-3"
      @on-complete="formSubmitted"
    >
      <template #prev>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="outline-light rounded-pill font-weight-bolder"
          size="lg"
        >
          Previous
        </b-button>
      </template>
      <template #next>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="info rounded-pill font-weight-bolder"
          size="lg"
        >
          Next
        </b-button>
      </template>
      <template #finish>
        <b-button
          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
          variant="info rounded-pill font-weight-bolder"
          size="lg"
        >
          Submit
        </b-button>
      </template>
      <!-- account detail tab -->
      <tab-content
        title="Account Details"
        icon="feather icon-file-text"
        :before-change="validationAccountDetails"
      >
        <validation-observer ref="accountDetails" tag="form">
          <b-row class="p-md-2 p-1">
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Account Details</h5>
              <small class="text-muted"> Enter Your Account Details. </small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="user-name"
                class="w-100"
                label="User name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="User name"
                  rules="min:4"
                >
                  <b-form-input
                    id="user-name"
                    v-model="username"
                    name="username"
                    placeholder="JohonDoe"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="email" class="w-100" label="Email">
                <validation-provider #default="{ errors }" name="Email">
                  <b-form-input
                    id="email"
                    disabled
                    v-model="email"
                    name="email"
                    placeholder="johndoe@example.com"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- <b-col md="6">
              <b-form-group
                label="Current password"
                label-for="reset-password-current"
              >
                <validation-provider
                  #default="{ errors }"
                  name="currentPassword"
                  vid="currentPassword"
                  rules="required|min:8|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="reset-password-current"
                      v-model="currentPassword"
                      :type="password3FieldType"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                      autocomplete="on"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password3ToggleIcon"
                        @click="togglePassword3Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="New password" label-for="reset-password-new">
                <validation-provider
                  #default="{ errors }"
                  name="New password"
                  vid="Password"
                  rules="required|min:8|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                      autocomplete="on"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="reset-password-confirm"
                label="Confirm Password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  :rules="`required|min:8|confirmed:${password}`"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false : null"
                      name="reset-password-confirm"
                      placeholder="············"
                      autocomplete="on"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- personal details -->
      <tab-content
        title="Personal Info"
        icon="feather icon-user"
        :before-change="validationPersonalInfo"
      >
        <validation-observer ref="personalInfo" tag="form">
          <b-row class="p-md-2 p-1">
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Personal Info</h5>
              <small class="text-muted">Enter Your Personal Info.</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label-for="full-name"
                class="w-100"
                label="Full name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Full name"
                  rules="required"
                >
                  <b-form-input
                    id="Full-name"
                    v-model="name"
                    name="name"
                    placeholder="Johon Doe"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="birthdate"
                class="w-100"
                rules="over18"
              >
                <b-form-group
                  label-for="birthdate"
                  class="w-100"
                  label="Birth date"
                >
                  <flat-pickr
                    @click.native="blurPicker"
                    id="birthdate"
                    v-model="birthdate"
                    class="form-control"
                    :config="{
                      dateFormat: 'Y-m-d',
                      enableTime: false,
                    }"
                    :state="errors.length > 0 ? false : null"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group label="Nationality" label-for="i-country">
                <validation-provider
                  #default="{ errors }"
                  name="Nationality"
                  :rules="mobile && !nationality ? 'required' : ''"
                >
                  <select-box
                    v-model="nationality"
                    label="text"
                    class="w-100"
                    searchable
                    url="country"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="mobile" class="w-100" label="Mobile">
                <validation-provider
                  #default="{ errors }"
                  name="Mobile"
                  rules="phone"
                >
                  <b-input-group
                    :prepend="
                      nationality && nationality.calling_code
                        ? nationality.calling_code
                        : ''
                    "
                  >
                    <b-form-input
                      id="mobile"
                      v-model="mobile"
                      name="mobile"
                      placeholder="+911234567890"
                      :state="errors.length > 0 ? false : null"
                    />
                  </b-input-group>
                  <small class="text-danger" v-if="nationality">{{
                    errors[0]
                  }}</small>
                  <small class="text-danger" v-if="mobile && !nationality"
                    >Please select your nationality first!
                  </small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address -->
      <tab-content
        title="Business Info"
        icon="feather icon-map-pin"
        :before-change="validationBusinessInfo"
      >
        <validation-observer ref="businessInfo" tag="form">
          <b-row class="p-md-2 p-1">
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Company information</h5>
              <small class="text-muted">Enter company information.</small>
            </b-col>
            <b-col md="6">
              <b-form-group label="Company name" label-for="i-company-name">
                <b-form-input
                  id="i-company-name"
                  placeholder="Apple"
                  v-model="company_name"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group label="Business scale" label-for="business-scale">
                <v-select
                  :options="businessScales"
                  v-model="business_scale"
                  :searchable="false"
                  label="scale"
                  :reduce="(option) => option.value"
                ></v-select>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <validation-provider
                #default="{ errors }"
                name="Website"
                class="w-100"
                rules="url"
              >
                <b-form-group
                  label-for="website"
                  label="website ( example : http://www.example.com or www.example.com or example.com )"
                >
                  <b-form-input
                    id="website"
                    v-model="website"
                    name="website"
                    placeholder="http://www.example.com"
                    :state="errors.length > 0 ? false : null"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col md="6">
              <b-form-group label-for="audience" label="Audience">
                <b-form-input
                  id="audience"
                  v-model="audience"
                  name="audience"
                  type="number"
                  min="1"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col md="4" class="d-flex">
              <b-form-group
                label-for="i-business-description"
                label="Business description"
                class="w-100"
              >
                <b-form-textarea
                  id="i-business-description"
                  placeholder="Please give us a short description of your business, and it's main activity, etc. "
                />
              </b-form-group>
            </b-col> -->
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- social link -->
      <tab-content title="Social Links" icon="feather icon-link" class="pb-1">
        <b-row class="p-md-2 p-1">
          <b-col class="d-flex flex-wrap">
            <h4 class="col-md-12 px-0 mb-1">Socials</h4>
            <div class="col-md-6 pr-md-1 px-0 pb-2">
              <b-input-group prepend="@instagram">
                <b-form-input
                  id="instagram"
                  v-model="instagram"
                  name="instagram"
                />
              </b-input-group>
            </div>
            <div class="col-md-6 pl-md-1 px-0 pb-2">
              <b-input-group prepend="@telegram">
                <b-form-input
                  id="telegram"
                  v-model="telegram"
                  name="telegram"
                />
              </b-input-group>
            </div>
            <div class="col-md-6 pr-md-1 px-0 pb-2">
              <b-input-group prepend="@twitter">
                <b-form-input id="twitter" v-model="twitter" name="twitter" />
              </b-input-group>
            </div>
            <div class="col-md-6 pl-md-1 pb-2 px-0">
              <b-input-group prepend="@youtube">
                <b-form-input id="youtube" v-model="youtube" name="youtube" />
              </b-input-group>
            </div>
            <div class="col-md-6 pr-md-1 px-0 pb-2">
              <b-input-group prepend="@facebook">
                <b-form-input
                  id="facebook"
                  v-model="facebook"
                  name="facebook"
                />
              </b-input-group>
            </div>
            <div class="col-md-6 pl-md-1 pb-2 px-0">
              <b-input-group prepend="@linkedin">
                <b-form-input
                  id="linkedin"
                  v-model="linkedin"
                  name="linkedin"
                />
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </tab-content>
    </form-wizard>
    <loader :loading="loading" />
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BFormTextarea,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, phone, url } from "@validations";
import flatPickr from "vue-flatpickr-component";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import loader from "@core/components/loader/Loader.vue";
export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BButton,
    BFormTextarea,
    BInputGroupAppend,
    BInputGroup,
    SelectBox,
    flatPickr,
    loader,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      userData: JSON.parse(localStorage.getItem("userData")),
      username: "",
      name: "",
      email: "",
      logo: "",
      cover: "",
      mobile: "",
      nationality: "",
      company_name: "",
      website: "",
      birthdate: "",
      business_scale: "",
      audience: "",
      instagram: "",
      telegram: "",
      youtube: "",
      twitter: "",
      facebook: "",
      linkedin: "",
      businessScales: [
        {
          value: 10,
          scale: "0-10 employee",
        },
        {
          value: 50,
          scale: "10-50 employee",
        },
        {
          value: 500,
          scale: "50-500 employee",
        },
        {
          value: 1000,
          scale: "500-1000 employee",
        },
      ],
      currentPassword: "",
      cPassword: "",
      password: "",
      password1FieldType: "password",
      password2FieldType: "password",
      password3FieldType: "password",
      required,
      email,
      phone,
      url,
    };
  },
  created() {
    Object.keys(this.userData).map((key) => {
      if (key == "socials") {
        Object.keys(this[key]).map((socialKey) => {
          this[socialKey] = this.userData[key][socialKey];
        });
      } else {
        this[key] = this.userData[key];
      }
    });
  },
  directives: {
    Ripple,
  },
  computed: {
    socials() {
      return {
        instagram: this.instagram,
        telegram: this.telegram,
        youtube: this.youtube,
        twitter: this.twitter,
        facebook: this.facebook,
        linkedin: this.linkedin,
      };
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password3ToggleIcon() {
      return this.password3FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  methods: {
    async getPartner() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(`/panel/profile/partner`);
        await Object.keys(data.partner.data).map((item) => {
          if (item == "socials") {
            Object.keys(this.socials).map((social) => {
              this[social] = data.partner.data.socials[social];
            });
          } else {
            this[item] = data.partner.data[item];
          }
        });
        await localStorage.setItem(
          "userData",
          JSON.stringify({
            ...data.partner.data,
            documents: data.documents.data,
            type: "partner",
          })
        );
        await this.$store.dispatch("auth/setUserData", {
          ...data.partner.data,
          documents: data.documents.data,
          type: "partner",
        });
      } catch (err) {}
      this.loading = false;
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
    togglePassword3Visibility() {
      this.password3FieldType =
        this.password3FieldType === "password" ? "text" : "password";
    },
    validationAccountDetails() {
      return new Promise((resolve, reject) => {
        this.$refs.accountDetails.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationPersonalInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.personalInfo.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    validationBusinessInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.businessInfo.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject();
          }
        });
      });
    },
    async changeInfo() {
      this.formData = await new FormData();

      let newObject = await {
        username: this.username,
        name: this.name,
        email: this.email,
        mobile: this.mobile
          ? this.nationality.calling_code + this.mobile
          : this.mobile,
        nationality: this.nationality.id,
        company_name: this.company_name,
        website: this.website,
        birthdate: this.birthdate,
        business_scale: this.business_scale,
        audience: this.audience,
        socials: this.socials,
      };
      await Object.keys(newObject).map((item, index) => {
        this.setFormData(newObject[item], index, item);
      });
      try {
        const { data } = await this.$http.post(
          `/panel/profile/partner?_method=put`,
          this.formData
        );
        await this.getPartner();
        this.$router.push("/partner-registration/step3").catch((err) => {});
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Form Submitted",
            icon: "EditIcon",
            variant: "success",
          },
        });
      } catch (err) {}
      this.loading = false;
    },
    // async changePassword() {
    //   try {
    //     await this.$http.post(`/panel/profile/partner/password?_method=patch`, {
    //       current_password: this.currentPassword,
    //       password: this.password,
    //       password_confirmation: this.cPassword,
    //     });
    //   } catch (err) {}
    // },
    async formSubmitted() {
      this.loading = true;
      try {
        await this.changeInfo();
        // await this.changePassword();
        // await this.$emit("getProfile");
      } catch (err) {}
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

[dir]
  .vue-form-wizard
  .wizard-navigation
  .wizard-nav
  li
  .wizard-icon-circle
  .wizard-icon-container,
[dir]
  body.dark-layout
  .vue-form-wizard
  .wizard-navigation
  .wizard-nav
  li
  .wizard-icon-circle.checked {
  border: none !important;
  box-shadow: none;
  background: transparent !important;
}
[dir] .vue-form-wizard .wizard-navigation .wizard-nav {
  padding: 0 0 !important;
}

::placeholder {
  color: #898282 !important;
  opacity: 0.5 !important;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #898282 !important;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #898282 !important;
}
</style>
